import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import theme from '../../../styles/theme';
import AppButton from '../app-button/AppButton';
import { useStyles } from './AppBarWithButtons.styles';

interface IAppBarWithButtonsProps {
  cancelLabel?: string;
  submitLabel?: string;
  loading?: boolean;
  disabled?: boolean;
  cancelDisabled?: boolean;
  onClick?: () => void;
  onCancelClick: () => void;
}

export function AppBarWithButtons(props: IAppBarWithButtonsProps) {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    onCancelClick,
    cancelLabel = t('common.cancel'),
    submitLabel = t('common.save'),
    loading,
    disabled,
    onClick,
    cancelDisabled,
  } = props;

  return (
    <Box className={classes.buttonsWrapper}>
      <AppButton
        variant="outlined"
        disabled={cancelDisabled}
        onClick={onCancelClick}>
        {cancelLabel}
      </AppButton>
      <AppButton
        onClick={onClick}
        type={onClick ? 'button' : 'submit'}
        disabled={disabled}
        loader={loading}>
        {submitLabel}
      </AppButton>
    </Box>
  );
}
